import axios from 'axios';
import { getCookie } from '../utils/cookie-service';
import URI from 'urijs';

const MESSAGES_PER_PAGE = 30;
const baseUrl = URI(process.env.REACT_APP_BASE_API_URL).toString();

// Separate axios instance for messages API
const messageApi = axios.create({
  baseURL: baseUrl + 'messaging-service/api',
  timeout: 10000
});

messageApi.interceptors.request.use((config) => {
  const token = getCookie('veriipro-emp-chat-token') || '';

  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const messageService = {
  fetchMessages: async (candidateId, page = 1, fromFirstUnread = false) => {
    const response = await messageApi.get(`/messages/candidate/${candidateId}`, {
      params: { page, limit: MESSAGES_PER_PAGE, fromFirstUnread }
    });
    return response.data;
  },

  sendMessage: async (messageData) => {
    const response = await messageApi.post('/messages', messageData);
    return response.data;
  },

  markAsRead: async (chatId, userId) => {
    const response = await messageApi.patch('/messages/read', { chatId, userId });
    return response.data;
  }
};
